mapclick = function (path) {
    if (path.dataset.link) {
        window.open(path.dataset.link, '_blank')
    }
}